import React, { memo } from 'react';
import { ReactComponent as DescriptionIcon } from 'features/editor/assets/icons/Description.svg';
import { RenderElementProps } from 'slate-react';

import { elementTypes } from '../../constants/types';
import Box, { CollapsedLabel, RootWrapper, Title } from '../box';

const Description = ({
  attributes = { 'data-slate-node': 'element', ref: null },
  children = null,
  element = { type: elementTypes.DESCRIPTION, children: [] },
}: RenderElementProps) => {
  const { data } = element;
  const content = data?.content || '';

  return (
    <div {...attributes}>
      {children}
      <Box Icon={DescriptionIcon}>
        <RootWrapper>
          <CollapsedLabel>Description</CollapsedLabel>
          {content ? (
            <Title>{content}</Title>
          ) : (
            <Title italic>No content...</Title>
          )}
        </RootWrapper>
      </Box>
    </div>
  );
};

export default memo(Description);
